<template lang="pug">
  .container.container_mobile
    .grid.grid_h-center.grid_v-margins
      .grid__col.grid__col_lg-24.grid__col_xl-20
        .block.block_wide#rating
          .block__item.block__intro
            .block__intro-item.block__intro-item_md
              .members-header.grid.grid_v-center.grid_v-margins
                .grid__col.grid__col_lg-auto
                  .buttons-group.buttons-group_solid
                    button.button.button_sm(
                      v-for="option in weekOptions"
                      :key="option.id"
                      :class="{'buttons-group__active button_primary-bordered': params.week === option.id, 'button_secondary': params.week !== option.id}"
                      @click="changeWeek(option.id)"
                    )
                      span.button__text {{ option.name }}
                .grid__col.grid__col_lg-stretch
                  h2 {{ title }}
            .block__intro-item.block__intro-item_md(v-if="isLoaded" v-show="showFilters")
              .filters.d-none.d-md-block
                .filters__wrap
                  .filters__container
                    .filters__item.d-md-none
                      .filter
                        .filter__label Номинация:
                        .filter__value
                          Select(
                            v-model="nomination.val"
                            :value="nomination.val"
                            :options="nomination.options"
                            type="simple"
                            size="sm"
                            :searchable="false"
                            cls="multiselect_dropdown-auto"
                            ref="nomination"
                            @input="id => changeNomination(id)"
                          )
                    .filters__item(v-if="showDisciplineFilter")
                      .filter
                        .filter__label Тип тренировки:
                        .filter__value
                          Select(
                            v-model="params.discipline"
                            :value="params.discipline"
                            :options="clubDisciplineFilterValues"
                            type="simple"
                            size="sm"
                            :searchable="false"
                            cls="multiselect_dropdown-auto"
                            @input="() => { mobileParams.discipline = params.discipline; changeFilters() } "
                          )
                    .filters__item(v-if="showGenderFilter")
                      .filter
                        .filter__label Пол:
                        .filter__value
                          Select(
                            v-model="params.gender"
                            :value="params.gender"
                            :options="clubGenderFilterValues"
                            type="simple"
                            size="sm"
                            :searchable="false"
                            cls="multiselect_dropdown-auto"
                            @input="() => { mobileParams.gender = params.gender; changeFilters() } "
                          )
                    .filters__item(v-if="showCityFilter")
                      .filter
                        .filter__label Город:
                        .filter__value
                          Select(
                            v-model="params.location"
                            :value="params.location"
                            :options="clubCityFilterValues"
                            type="simple"
                            size="sm"
                            :searchable="false"
                            cls="multiselect_dropdown-auto"
                            @input="() => { mobileParams.location = params.location; changeFilters() } "
                          )
            // Mobile
            .block__intro-item.block__intro-item_md(v-if="isLoaded")
              .filters.filters_mobile.d-md-none
                .filters__wrap
                  .filters__container
                    .filters__item
                      MobileFilter(
                        v-model="nomination.mobileVal"
                        :text="getOptionName(nomination.options, nomination.val)"
                        :initialValue="nomination.val"
                        name="Номинация"
                        @change="val => { nomination.val = val; changeNomination(val) }"
                      )
                        template(slot="filter")
                          Radio(
                            v-for="option in nomination.options"
                            :key="option.id"
                            class="w-100"
                            v-model="nomination.mobileVal"
                            :value="option.id"
                            :label="option.name"
                          )
                    .filters__item(v-if="showDisciplineFilter")
                      MobileFilter(
                        v-model="mobileParams.discipline"
                        :text="getOptionName(clubDisciplineFilterValues, params.discipline)"
                        :initialValue="params.discipline"
                        name="Тип тренировки"
                        @change="val => { params.discipline = val; changeFilters() }"
                      )
                        template(slot="filter")
                          Radio(
                            v-for="option in clubDisciplineFilterValues"
                            :key="option.id"
                            class="w-100"
                            v-model="mobileParams.discipline"
                            :value="option.id"
                            :label="option.name"
                          )
                    .filters__item(v-if="showGenderFilter")
                      MobileFilter(
                        v-model="mobileParams.gender"
                        :text="getOptionName(clubGenderFilterValues, params.gender)"
                        :initialValue="params.gender"
                        name="Пол"
                        @change="val => { params.gender = val; changeFilters() }"
                      )
                        template(slot="filter")
                          Radio(
                            v-for="option in clubGenderFilterValues"
                            :key="option.id"
                            class="w-100"
                            v-model="mobileParams.gender"
                            :value="option.id"
                            :label="option.name"
                          )
                    .filters__item(v-if="showCityFilter")
                      MobileFilter(
                        v-model="mobileParams.location"
                        :text="getOptionName(clubCityFilterValues, params.location)"
                        :initialValue="params.location"
                        name="Город"
                        @change="val => { params.location = val; changeFilters() }"
                      )
                        template(slot="filter")
                          Radio(
                            v-for="option in clubCityFilterValues"
                            :key="option.id"
                            class="w-100"
                            v-model="mobileParams.location"
                            :value="option.id"
                            :label="option.name"
                          )
            .block__intro-item.block__intro-item_md(v-if="!isLoaded")
              table.table.table_default.table_striped
                thead.table__header
                  tr
                    th(v-for="j in 4"): Skeleton
                tbody
                  tr(v-for="i in 4")
                    td(v-for="k in 4"): Skeleton
            .block__intro-item.block__intro-item_md(v-else)
              section.empty-state(v-show="!clubRatingCount")
                .loader.m-0(v-show="clubRatingLoading")
                .section__group.mt-0(v-show="!clubRatingLoading")
                  .section__item Нет участников под&nbsp;ваш запрос&nbsp;😔
              .table-container(v-show="clubRatingCount")
                table.table.table_default.table_striped
                  colgroup
                    col(width="1")
                    col(width="245")
                  thead.table__header
                    tr
                      th Место
                      th(style="min-width: 150px;") Участник
                      th.text-right.d-md-table-cell(
                        v-for="sortOption in sortOptions"
                        :class="{ 'bg-black-4 color-primary': !singleMember && params.sortBy === sortOption.id, 'd-none': params.sortBy !== sortOption.id }"
                        style="min-width: 100px;"
                      )
                        div(
                          :class="{ 'table-sort': !singleMember}"
                          @click.prevent="changeSort(sortOption)"
                        ) {{ sortOption.name }}&nbsp;
                          span(v-show="!singleMember")
                            span(v-show="params.sortBy === sortOption.id && params.sortOrder === sortOption.order") ↓
                            span(v-show="params.sortBy === sortOption.id && params.sortOrder !== sortOption.order") ↑
                  tbody(:class="{ 'table__loading': clubRatingLoading }")
                    tr.table__loader
                      td(colspan="7")
                        .loader.m-0
                    tr(
                        v-for="member in clubRating"
                        :class="{'table__highlight text-semibold': member.id === user.id}"
                      )
                        td {{ member.position }}
                        td
                          Member(
                            :userId="member.id"
                            :name="member.fullName"
                            :img="member.avatarSmallUrl"
                          )
                            template
                              .text-xs.d-none.d-lg-block {{ memberLocation(member.city, member.country) }}
                        td.text-right.text-nowrap.d-md-table-cell(
                          v-for="sortOption in sortOptions"
                          :class="{'bg-black-4': !singleMember && params.sortBy === sortOption.id, 'd-none': params.sortBy !== sortOption.id}"
                        )
                          span.text-lg(v-html="getMemberValue(member, sortOption)")
          .block__item(v-if="isLoaded" v-show="pagination.totalItems > pagination.itemsPerPage")
            pagination(
              :page="params.page - 1"
              :totalItems="pagination.totalItems"
              :itemsPerPage="pagination.itemsPerPage"
              :disabled="pagination.disabled"
              @change="changePage"
            )
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
import { clone, isEqual, isEmpty, find } from 'lodash'
import { scrollToId } from '@/assets/js/animation'
import { Skeleton } from 'vue-loading-skeleton'
import Select from '@/components/Select'
import Member from '@/components/Member'
import Pagination from '@/components/Pagination'
import Radio from '@/components/Radio'
import MobileFilter from '@/components/MobileFilter'

const defaultParams = {
  page: 1,
  week: 'current',
  discipline: 'run',
  gender: 'any',
  location: 'any',
  sortBy: 'totalDistance',
  sortOrder: 'desc'
}

export default {
  name: 'ClubMembers',
  components: {
    Skeleton,
    Select,
    Member,
    Pagination,
    Radio,
    MobileFilter
  },
  props: {
    club: Object
  },
  data () {
    return {
      clubCode: null,
      params: clone(defaultParams),
      mobileParams: clone(defaultParams),
      pagination: {
        disabled: false,
        itemsPerPage: 25,
        totalItems: 0
      },
      weekOptions: [
        { id: 'last', name: 'Прошлая неделя', title: 'Рейтинг прошлой недели' },
        { id: 'current', name: 'Текущая неделя', title: 'Рейтинг этой недели' }
      ],
      sortOptions: [
        { id: 'totalDistance', name: 'Дистанция', order: 'desc', valueUnits: 'км', nullValue: '--' },
        { id: 'averagePace', name: 'Ср. темп', order: 'desc', valueUnits: '/км', nullValue: '--' },
        { id: 'totalHeight', name: 'Набор высоты', order: 'desc', valueUnits: 'м', nullValue: '--' },
        { id: 'activityCount', name: 'Тренировки', order: 'desc', valueUnits: '', nullValue: 0 },
        { id: 'topDistance', name: 'Самая длинная', order: 'desc', valueUnits: 'км', nullValue: '--' }
      ],
      nomination: {
        val: 'totalDistance',
        mobileVal: 'totalDistance',
        options: []
      }
    }
  },
  computed: {
    ...mapState('user', ['user']),
    ...mapState('clubRating', ['clubRating', 'clubRatingCount', 'clubRatingSettings', 'clubRatingLoading']),
    ...mapState('club', ['clubInfo', 'clubFilters', 'membersUpdateTrigger']),
    ...mapState('clubs', ['clubsFilters']),
    ...mapGetters('club', ['clubCityFilterValues', 'clubDisciplineFilterValues', 'clubGenderFilterValues', 'clubGenderFilterValues']),
    title () {
      const active = find(this.weekOptions, o => o.id === this.params.week)
      return active ? active.title : 'Рейтинг этой недели'
    },
    singleMember () {
      return this.clubRatingCount < 2
    },
    showDisciplineFilter () {
      return this.clubDisciplineFilterValues.length > 1
    },
    showGenderFilter () {
      return this.clubGenderFilterValues.length > 2
    },
    showCityFilter () {
      return this.clubInfo &&
        this.clubInfo.membersCount > 1 &&
        this.clubCityFilterValues.length > 1
    },
    showFilters () {
      return this.showDisciplineFilter || this.showGenderFilter || this.showCityFilter
    },
    idClub () {
      return this.$route.params.id || this.$getTenantIdClub()
    },
    isLoaded () {
      return this.clubRating && this.$store.state.clubRating.clubCode === this.idClub && !isEmpty(this.clubFilters)
    }
  },
  methods: {
    ...mapActions('club', ['getClubFilters']),
    ...mapActions('clubRating', ['getClubRating']),
    ...mapMutations('clubRating', ['saveClubRatingSettings', 'saveClubRating']),
    getOptionName (options, id) {
      if (!id) {
        return null
      }
      for (let i = 0; i < options.length; i += 1) {
        const option = options[i]
        if (option.id === id) {
          return option.name
        }
      }
      return null
    },
    getMemberValue (member, sortOption) {
      if (!member[sortOption.id]) {
        return sortOption.nullValue
      }
      const units = sortOption.valueUnits ? '&nbsp;<span class="text-xs">' + sortOption.valueUnits + '</span>' : ''
      return member[sortOption.id] + units
    },
    memberLocation (city, country) {
      if (!city) {
        return null
      }
      let result = city
      if (country) {
        result += ', ' + country
      }
      return result
    },
    changePage (page) {
      scrollToId('rating', undefined, 0)
      this.pageChanging = true
      this.params.page = page + 1
      this.filterClubs()
    },
    changeWeek (id) {
      if (this.params.week === id) {
        return
      }
      this.params.week = id
      this.filterClubs({ resetPage: true })
    },
    changeSort (sortOption) {
      if (this.singleMember) {
        return
      }
      let order = sortOption.order
      if (this.params.sortBy === sortOption.id) {
        order = this.params.sortOrder === 'asc' ? 'desc' : 'asc'
      }
      this.params.sortBy = sortOption.id
      this.params.sortOrder = order

      this.filterClubs({ resetPage: true })
    },
    changeFilters () {
      this.filterClubs({ resetPage: true })
    },
    changeNomination (id) {
      this.params.sortBy = id
      this.params.sortOrder = this.$refs.nomination.val.order
      if (this.clubInfo && this.clubInfo.membersCount > 1) {
        this.filterClubs({ resetPage: true })
      }
    },
    filterClubs ({ resetPage } = {}) {
      const isChanged = !isEqual(this.params, this.clubRatingSettings)
      if (isChanged) {
        if (resetPage) {
          this.params.page = defaultParams.page
          this.pagination.disabled = true
        }
        this.setQuery()
        this.loadItems()
      }
    },
    setQuery () {
      const query = {}

      for (const key in this.params) {
        const param = this.params[key]
        if (param !== defaultParams[key]) {
          query[key] = param
        }
      }
      this.$router.replace({
        query: query
      })

      this.saveClubRatingSettings(clone(this.params))
    },
    parseQuery () {
      const query = this.$route.query

      for (const key in this.params) {
        if (query[key]) {
          this.params[key] = query[key]
          this.mobileParams[key] = query[key]
        }
      }

      if (Math.ceil(this.pagination.totalItems / this.pagination.itemsPerPage) < query.page) {
        this.params.page = defaultParams.page
      }

      const isChanged = !isEqual(this.params, this.clubRatingSettings)
      if (!this.clubRating || isChanged) {
        this.loadItems()
      }
      this.nomination.val = this.nomination.mobileVal = this.params.sortBy
      this.saveClubRatingSettings(clone(this.params))
    },
    loadItems () {
      const data = {
        clubCode: this.clubCode,
        disciplineCode: this.params.discipline,
        week: this.params.week,
        gender: this.params.gender,
        sortBy: this.params.sortBy,
        sortOrder: this.params.sortOrder,
        page: this.params.page,
        pageSize: this.pagination.itemsPerPage
      }
      if (this.params.location !== 'any') {
        data.city = this.params.location
      }
      this.getClubRating({ data, cancel: true, clubCode: this.clubCode })
    }
  },
  watch: {
    clubRatingLoading (val) {
      if (!val) {
        this.pagination.totalItems = this.clubRatingCount
        this.pagination.disabled = false
        if (this.pageChanging) {
          this.$nextTick(() => {
            scrollToId('rating', undefined, 0)
          })
          this.pageChanging = false
        }
      }
    },
    membersUpdateTrigger () {
      this.getClubFilters(this.clubCode)
      this.filterClubs({ resetPage: true })
    },
    'clubInfo.membersCount' (val) {
      if (!val) {
        this.$router.replace({
          name: 'Club',
          params: { id: this.idClub }
        })
      }
    }
  },
  created () {
    this.clubCode = this.$route.params.id || this.$getTenantIdClub()
    this.nomination.options = this.sortOptions
    if (this.clubCode !== this.$store.state.clubRating.clubCode) {
      this.saveClubRating({
        items: null,
        totalCount: 0
      })
      const query = this.$route.params
      if (query.page) {
        delete query.page
        this.$router.replace({
          name: 'ClubMembers',
          params: query
        })
      }
    }
    this.pagination.totalItems = this.clubRatingCount
    this.getClubFilters(this.clubCode)
    this.parseQuery()
  }
}
</script>

<style lang="scss" scoped>
  .filters_mobile {
    margin-left: -24px;
    margin-right: -24px;
    padding-left: 24px;
    padding-right: 24px;
  }
</style>

<style lang="scss">
  .members-header {

    @media (min-width: breakpoint(lg)) {
      flex-direction: row-reverse;
    }
  }

  .member {

    &__container {
      display: flex;
      align-items: center;
    }

    &__img {
      flex: 0 0 auto;
      margin-right: 8px;

      @media (min-width: breakpoint(lg)) {
        margin-right: 12px;
      }
    }
  }
</style>
